// config/index.tsx

import { http, createConfig } from "wagmi";
import { berachain } from "viem/chains";
import { injected, metaMask, walletConnect } from "wagmi/connectors";

export const projectId = "fb297a4ca0bff468a184d944ed22510a";

export const config = createConfig({
  chains: [berachain] as const,
  connectors: [
    walletConnect({
      projectId: projectId,
      showQrModal: true,
    }),
  ],
  transports: {
    [berachain.id]: http(),
  },
});
